/* eslint-disable no-restricted-properties */

/** Same as "window.location.href = X" or "window.location.assign()". Intended for navigating to a URL outside the SPA. */
export function navigateToExternalUrl(url: string, options: { replaceHistory?: boolean } = {}) {
  if (options.replaceHistory) {
    window.location.replace(url)
  } else {
    window.location.assign(url)
  }
}

/** Same as getting "window.location.hash". Bypasses the react-router history implementation, which doesn't scroll to the element. */
export function getHash() {
  return window.location.hash
}

/** Same as setting "window.location.hash". Bypasses the react-router history implementation, which doesn't scroll to the element. */
export function navigateToHash(hash: string) {
  window.location.hash = hash
}

/** Same as "window.location.reload()". */
export function reloadPage() {
  window.location.reload()
}

/** Same as window.location.origin. */
export function getOrigin() {
  return window.location.origin
}

/** Same as window.location.href. */
export function getHref() {
  return window.location.href
}

/** Same as window.location.protocol. */
export function getProtocol() {
  return window.location.protocol
}
